import ApplicationController from './application_controller'
import { Turbo } from '@hotwired/turbo-rails'
import { format } from 'date-fns'

export default class extends ApplicationController {
  static targets = ['quarter']
  static outlets = ['kaia--tabs-component', 'kaia--datepicker-component']
  static values = { url: String, viewParam: String }

  DATE_FORMAT = 'yyyy-MM-dd'

  enableMtuTabs() {
    this.kaiaTabsComponentOutlet.element.classList.remove('hidden')
  }

  disableMtuTabs() {
    this.kaiaTabsComponentOutlet.element.classList.add('hidden')
  }

  toggleQuartersForPeriod({ params: { periodIndex } }) {
    this.#toggleQuarters(this.#quartersInPeriod(periodIndex))
  }

  showQuarterly() {
    this.#toggleQuarters(this.quarterTargets, true)
  }

  showHourly() {
    this.#toggleQuarters(this.quarterTargets, false)
  }

  kaiaDatepickerComponentOutletConnected(outlet) {
    outlet.onDateClick = () => this.changeDate()
  }

  changeDate() {
    const date = format(this.selectedDate, this.DATE_FORMAT)
    const url = `${this.urlValue}?date=${date}`
    if (this.hasViewParamValue) url.concat(`&v=${this.viewParamValue}`)
    Turbo.visit(url, {
      frame: this.viewParamValue === 'direct' ? '_top' : 'time_series'
    })
  }

  #toggleQuarters(quarterEls, show = undefined) {
    if (typeof show === 'undefined')
      quarterEls.forEach((quarterEl) => quarterEl.classList.toggle('hidden'))
    else
      quarterEls.forEach((quarterEl) =>
        quarterEl.classList.toggle('hidden', !show)
      )
  }

  #quartersInPeriod(periodIndex) {
    return this.quarterTargets.filter(
      (quarter) =>
        parseInt(
          quarter.getAttribute('data-day-details-period-index-param')
        ) === periodIndex
    )
  }

  get selectedDate() {
    return this.kaiaDatepickerComponentOutlet.selectedDate
  }
}
